import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const FAQS = [
  {
    id: "timeline",
    q: "How long does it take to build my website?",
    a: "Most small-business websites are ready to launch within a few weeks. The exact timeline depends on the size of your site and how quickly feedback is shared — your personalized quote will include an expected timeframe before you commit.",
  },
  {
    id: "content",
    q: "Do I need to write my own content?",
    a: "You know your business best, so we'll start with what you have — your services, business details, and any photos — and shape it into clear, professional pages. No writing experience required; we guide you through exactly what's needed.",
  },
  {
    id: "redesign",
    q: "Can you redesign my existing website?",
    a: "Absolutely. We'll review your current website and recommend a redesign, enhancement, or migration depending on its current platform — then give it a fresh, modern look with a better experience across every device.",
  },
  {
    id: "mobile",
    q: "Will my website work on phones and tablets?",
    a: "Yes. Every website we build is mobile-responsive, so it looks and works beautifully on phones, tablets, and desktops alike — where most of your customers will find you.",
  },
  {
    id: "hosting",
    q: "Is hosting required?",
    a: "Websites we build and host include a required monthly managed hosting and care plan. It covers reliable hosting, SSL support, technical maintenance, and minor content updates. Your proposal will clearly outline both the one-time project cost and the ongoing monthly fee before you commit.",
  },
];

const Faq = () => (
  <section id="faq" data-testid="faq-section" className="bg-cream py-20 md:py-28">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="text-xs font-sans uppercase tracking-[0.28em] font-semibold text-turquoise-deep mb-5 flex items-center justify-center gap-3">
          <span className="w-10 h-px bg-turquoise inline-block" />
          FAQ
          <span className="w-10 h-px bg-turquoise inline-block" />
        </p>
        <h2 className="font-serif font-medium tracking-tight text-charcoal text-2xl sm:text-3xl lg:text-4xl leading-tight">
          Questions, <span className="italic text-turquoise">Answered.</span>
        </h2>
      </Reveal>

      <Reveal delay={0.12}>
        <Accordion type="single" collapsible className="mt-12">
          {FAQS.map((f) => (
            <AccordionItem
              key={f.id}
              value={f.id}
              data-testid={`faq-item-${f.id}`}
              className="border-b border-taupe/15"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${f.id}`}
                className="font-serif font-medium text-lg text-charcoal hover:text-turquoise-deep hover:no-underline text-left py-6 transition-colors duration-300"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="font-sans text-sm text-taupe leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
